export default __webpack_public_path__ + "static/media/derechos-reservados.5094ddce.svg";